import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteChangeProvider"] */ "/vercel/path0/frontend/components/route-change-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/smooth-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/frontend/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/frontend/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/frontend/contexts/ToastContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
